

import React, { useState, useEffect, useRef } from "react";

import "./Photos.css";

const Thumbnail = React.memo(({ src, alt = "", id, clickHandler }) => {
  const [loading, setLoading] = useState(true);
  const [spanHeight, setSpanHeight] = useState(0);
  const imageRef = useRef(null);

  useEffect(() => {
    const imageToLoad = new Image();
    imageToLoad.src = src;
    imageToLoad.onload = () => {
      setLoading(false);
    };
  }, [src]);

  useEffect(() => {
    if (imageRef.current) {
      const handleImageLoad = () => {
        if (imageRef.current) {
          const height = Math.ceil(imageRef.current.clientHeight / 10);
          setSpanHeight(height);
        }
      };
      imageRef.current.addEventListener("load", handleImageLoad);
      return () => {
        if (imageRef.current) {
          imageRef.current.removeEventListener("load", handleImageLoad);
        }
      };
    }
  }, []);

  return (
    <div style={{ gridRowEnd: `span ${spanHeight}` }}>
      <img
        // lowsrc={src.replace("thumbnail", "lowres")}

        onClick={clickHandler}
        ref={imageRef}
        id={id}
        // src={src.replace("thumbnail", "lowres")}
        src={src}
        style={{
          minHeight: 200,
          opacity: loading ? 0.2 : 1,
          transition: "opacity .15s linear",
        }}
        alt={alt}
      />
    </div>
  );
});

export default Thumbnail;
